/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Lead1Inputs */

const ja_playdata_eventreport_lead1 = /** @type {(inputs: Playdata_Eventreport_Lead1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2000個以上のeスポーツイベントのデータを保持しています。`)
};

const en_playdata_eventreport_lead1 = /** @type {(inputs: Playdata_Eventreport_Lead1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We hold data on more than 2,000 esports events.`)
};

/**
* | output |
* | --- |
* | "We hold data on more than 2,000 esports events." |
*
* @param {Playdata_Eventreport_Lead1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_lead1 = /** @type {((inputs?: Playdata_Eventreport_Lead1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Lead1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_lead1(inputs)
	return en_playdata_eventreport_lead1(inputs)
});
export { playdata_eventreport_lead1 as "playdata_eventReport_lead" }